import React from 'react';
import { Link, Outlet } from 'react-router-dom';
function Report() {
    return (
        <div className="p-2">
            <span className='title'>Report</span>
            <div className="row gap-3 mt-2">
                <div className="col-md-4 abcded rounded">
                    <Link to="/report/leave-external-report" className="text-decoration-none">
                        <div className="setting-layout text-center">
                            <i class="fa fa-regular fa-user mb-3"></i>
                            <span>User Report</span>
                        </div>
                    </Link>
                </div>
                <div className="col-md-4 abcded rounded">
                    <Link to="/report/leave-report-employee-leave-request" className="text-decoration-none">
                        <div className="setting-layout text-center rounded">
                            <i class="fa fa-list mb-3"></i>
                            <span >Leave Report</span>
                        </div>
                    </Link>
                </div>
            </div>

            <Outlet />
        </div>
    );

}

export default Report;
